import XLRLogger from 'src/common/helpers/logger';
import { getPaymentTenderOptions } from 'src/home-page/business-logic/get-payment-options';
import { tenderSuggestedAmountLookup } from 'src/home-page/business-logic/service/tender-suggested-amounts-lookup';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { ITender } from '../../common/interfaces/dtos/ITender';
import { store } from '../../common/redux/configure-store';
import { TenderMenuActions } from '../../common/redux/reducers/tender-menu-reducer';
import { AmountEntryOption } from '../enumerations/amount-entry-option';

// the suggested amounts code in here is needed for r10 just FYI

const handleTenderSelection = async (selectedTender?: ITender): Promise<void> => {
  if (!selectedTender) {
    return;
  }

  const amountDue = store.getState().itemList.amountDue;

  // had to do it like this for the test to pick up the mock for some reason
  const config = getCurrentXLRConfig();
  // this is only for r10 rn
  if (!selectedTender.amountEntryRequired && config.dynamicTender) {
    await getPaymentTenderOptions(selectedTender.id)
      .then(option => {
        selectedTender.amountEntryRequired = option.amountEntryOption;
        store.dispatch(TenderMenuActions.updateTender(selectedTender));
      })
      .catch(error => {
        XLRLogger.error({
          message: 'Error retrieving full tender details',
          source: 'handle-tender-selection',
          data: error,
        });
      });
  }

  if (needSuggestedTenderAmounts(selectedTender, amountDue)) {
    const transactionId = store.getState().transaction.transactionId;
    await tenderSuggestedAmountLookup(transactionId, selectedTender?.id ?? '')
      .then(amounts => {
        store.dispatch(TenderMenuActions.setSuggestedTenderAmount(amounts));
      })
      .catch(error => {
        XLRLogger.error({
          message: 'Error retrieving suggested amounts',
          source: 'handle-tender-selection',
          data: error,
        });
      });
  }
};

// Since getValidSellableTender returns tenders with suggested amounts, in most case getSuggestedAmount won't be called

const needSuggestedTenderAmounts = (selectedTender: ITender, amountDue: number): boolean => {
  return (
    isTenderWithSuggestedAmountsOrPreEnteredDetails(selectedTender) &&
    !isAmountDueSameAsFirstSuggestedAmount(selectedTender, amountDue)
  );
};

const isTenderWithSuggestedAmountsOrPreEnteredDetails = (tender: ITender): boolean => {
  return (
    tender.amountEntryRequired === AmountEntryOption.YesWithSuggestedAmounts ||
    !!(tender.vouchersDetails && tender.vouchersDetails.length)
  );
};

const isAmountDueSameAsFirstSuggestedAmount = (tender: ITender, amountDue: number): boolean => {
  return !!tender.suggestedAmounts && tender.suggestedAmounts[0] === amountDue;
};

export default handleTenderSelection;
